var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.489 0.5 0 4.989 0 10.5C0 16.011 4.489 20.5 10 20.5C15.511 20.5 20 16.011 20 10.5C20 4.989 15.511 0.5 10 0.5ZM10 2.5C14.4301 2.5 18 6.06988 18 10.5C18 14.9301 14.4301 18.5 10 18.5C5.56988 18.5 2 14.9301 2 10.5C2 6.06988 5.56988 2.5 10 2.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.4996C9.73478 5.4996 9.48043 5.60497 9.29289 5.79251C9.10536 5.98005 9 6.23439 9 6.4996V9.4996H6C5.73478 9.4996 5.48043 9.60497 5.29289 9.79251C5.10536 9.98005 5 10.2344 5 10.4996C5 10.7648 5.10536 11.0192 5.29289 11.2067C5.48043 11.3943 5.73478 11.4996 6 11.4996H9V14.4996C9 14.7648 9.10536 15.0192 9.29289 15.2067C9.48043 15.3943 9.73478 15.4996 10 15.4996C10.2652 15.4996 10.5196 15.3943 10.7071 15.2067C10.8946 15.0192 11 14.7648 11 14.4996V11.4996H14C14.2652 11.4996 14.5196 11.3943 14.7071 11.2067C14.8946 11.0192 15 10.7648 15 10.4996C15 10.2344 14.8946 9.98005 14.7071 9.79251C14.5196 9.60497 14.2652 9.4996 14 9.4996H11V6.4996C11 6.23439 10.8946 5.98005 10.7071 5.79251C10.5196 5.60497 10.2652 5.4996 10 5.4996Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.b6e65addfbf1f0a09f7cd8f67ed48813.svg";
export { ForwardRef as ReactComponent };